import React, { useState, useEffect } from 'react';
import { FormGroup } from 'src/components/ui';
import InputMask from 'react-input-mask';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';
import useTestId from '../../hooks/useTestId';
import { useAutofillSafeName } from '../../hooks/useAutofillSafeName';

export default function MoneyInput(props) {
  const { id, required, disabled, readonly, autofocus, onChange: onChangeForm, schema, value } = props;
  const [current, setCurrent] = useState(value);
  const { title } = schema;
  const testIdProps = useTestId(id);
  const autofillSafeName = useAutofillSafeName();

  useDebouncedEffect(
    () => {
      if (current !== value) {
        onChangeForm(parseFloat(current));
      }
    },
    [current],
    450
  );

  useEffect(() => setCurrent(value), [value]);

  const maskToCurrency = ({ nextState }) => {
    let { value } = nextState || {};

    value = value?.replace?.(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');

    return {
      ...nextState,
      value,
    };
  };

  return (
    <FormGroup>
      <label className="control-label">{title}</label>
      <InputMask
        disabled={disabled}
        name={autofillSafeName}
        autoComplete="off"
        className="form-control"
        value={current || ''}
        required={required}
        beforeMaskedStateChange={maskToCurrency}
        onChange={e => setCurrent(e.target.value)}
        readOnly={readonly}
        autoFocus={autofocus}
        id={id}
        {...testIdProps}
      />
    </FormGroup>
  );
}
